export const appInstanceId = 'snagUserUuid';
